var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V25H25V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 22.5H1.5625C1.14805 22.5 0.750585 22.6317 0.457617 22.8661C0.164648 23.1005 0 23.4184 0 23.75C0 24.0816 0.164648 24.3995 0.457617 24.6339C0.750585 24.8683 1.14805 25 1.5625 25H23.4375C23.852 25 24.2494 24.8683 24.5424 24.6339C24.8354 24.3995 25 24.0816 25 23.75C25 23.4184 24.8354 23.1005 24.5424 22.8661C24.2494 22.6317 23.852 22.5 23.4375 22.5ZM11.3906 19.6375C11.5393 19.7513 11.7145 19.8405 11.9063 19.9C12.0934 19.9661 12.2955 20.0003 12.5 20.0003C12.7045 20.0003 12.9066 19.9661 13.0938 19.9C13.2855 19.8405 13.4607 19.7513 13.6094 19.6375L19.8594 14.6375C20.1535 14.4022 20.3189 14.0828 20.3189 13.75C20.3189 13.4172 20.1535 13.0978 19.8594 12.8625C19.5652 12.6272 19.166 12.4948 18.75 12.4948C18.334 12.4948 17.9348 12.6272 17.6406 12.8625L14.0625 15.7375V1.25C14.0625 0.918485 13.8979 0.600531 13.6049 0.36611C13.3119 0.131703 12.9145 0 12.5 0C12.0855 0 11.6881 0.131703 11.3951 0.36611C11.1021 0.600531 10.9375 0.918485 10.9375 1.25V15.7375L7.35937 12.8625C7.21367 12.7459 7.04082 12.6534 6.85039 12.5905C6.65996 12.5273 6.45605 12.4948 6.25 12.4948C6.04395 12.4948 5.84004 12.5273 5.64961 12.5905C5.45918 12.6534 5.28633 12.7459 5.14063 12.8625C4.99492 12.9791 4.8793 13.1173 4.80059 13.2697C4.72168 13.422 4.68105 13.5852 4.68105 13.75C4.68105 13.9148 4.72168 14.078 4.80059 14.2303C4.8793 14.3827 4.99492 14.5209 5.14063 14.6375L11.3906 19.6375Z",
    fill: "#ADB5BD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.12e24629fb6088f16632bf15a2fa8f8c.svg";
export { ForwardRef as ReactComponent };